import checkPermission from '@/middleware/checkPermission';

const Login = () => import('@/pages/auth/Login.vue');
const OTP = () => import('@/pages/auth/OTP.vue');
const ResetPassword = () => import('@/pages/auth/ResetPassword.vue');

const Category = () => import('@/pages/Index.vue');

const Home = () => import('@/pages/dashboard/home/Index.vue');

const Customer360 = () => import('@/pages/reports/customer-360/Index.vue');

const TemplateFolder = () =>
  import('@/pages/builder/template/directory/Index.vue');
const TemplateFiles = () =>
  import('@/pages/builder/template/directory/Index.vue');
const TemplateEmailForm = () =>
  import('@/pages/builder/template/form/email/Index.vue');
const TemplatePopupForm = () =>
  import('@/pages/builder/template/form/popup/Index.vue');
const TemplateWebForm = () =>
  import('@/pages/builder/template/form/web/Index.vue');

const TargetGroupsFolder = () =>
  import('@/pages/builder/target-groups/directory/Index.vue');
const TargetGroupsFiles = () =>
  import('@/pages/builder/target-groups/directory/Index.vue');
const TargetGroupsForm = () =>
  import('@/pages/builder/target-groups/form/create/Index.vue');

const UserGroup = () => import('@/pages/user-management/user-group/Index.vue');
const UserGroupForm = () =>
  import('@/pages/user-management/user-group/Form.vue');

const User = () => import('@/pages/user-management/user/Index.vue');
const Profile = () => import('@/pages/profile/Index.vue');
const Campaigns = () => import('@/pages/builder/campaigns/Index.vue');
const CreateCampaign = () =>
  import('@/pages/builder/campaigns/components/CreateCampaign.vue');
const Webhooks = () => import('@/pages/builder/webhooks/Index.vue');
const CreateWebhook = () =>
  import('@/pages/builder/webhooks/CreateWebhook.vue');
const Planner = () => import('@/pages/builder/planner/Index.vue');
const BrandDefaults = () =>
  import('@/pages/system-settings/brand-defaults/Index.vue');
const ShortLinks = () =>
  import('@/pages/system-settings/short-links/Index.vue');
const IntegrationSetup = () =>
  import('@/pages/system-settings/integration-setup/Index.vue');
const EditIntegrationSetup = () =>
  import(
    '@/pages/system-settings/integration-setup/components/forms/EditIntegrationSetup.vue'
  );
const CreateIntegrationSetup = () =>
  import(
    '@/pages/system-settings/integration-setup/components/forms/CreateIntegrationSetup.vue'
  );
const GlobalSettings = () => import('@/pages/system-settings/global/Index.vue');
const UserActivity = () => import('@/pages/monitoring/user-activity/Index.vue');
const UserCreate = () => import('@/pages/user-management/user/UserCreate.vue');
const UserEdit = () => import('@/pages/user-management/user/UserEdit.vue');
const CampaignImpression = () =>
  import('@/pages/reports/campaign-impression/Index.vue');

const NotFound = () => import('@/pages/misc/404.vue');
const Unauthorized = () => import('@/pages/misc/403.vue');

const Authenticated = () => import('@/layouts/authenticated/Index.vue');
const ManageExclusions = () =>
  import('@/pages/builder/exclusions/ManageExclusions.vue');

const routes = [
  {
    meta: {
      layout: 'guest',
    },
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    meta: {
      layout: 'guest',
    },
    path: '/otp',
    name: 'OTP',
    component: OTP,
  },
  {
    meta: {
      layout: 'guest',
    },
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: ResetPassword,
  },

  {
    path: '/dashboard',
    component: Category,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: Home,
        meta: {
          middleware: checkPermission,
          permissions: {
            moduleId: 1,
            actions: ['view'],
          },
        },
      },
    ],
  },

  {
    path: '/builder',
    component: Category,
    children: [
      {
        path: 'template',
        component: Category,
        meta: {
          middleware: checkPermission,
          permissions: {
            moduleId: 2,
            actions: ['view'],
          },
        },
        children: [
          {
            // folder
            path: '',
            name: 'template-folders',
            component: TemplateFolder,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 2,
                actions: ['view'],
              },
            },
          },
          {
            // files
            path: ':folder_id',
            name: 'template-files',
            component: TemplateFolder,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 13,
                actions: ['view'],
              },
            },
          },
          {
            path: ':folder_id/email/:file_id?',
            name: 'template-email',
            component: TemplateEmailForm,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 13,
                actions: ['view'],
              },
            },
          },
          {
            path: ':folder_id/popup/:file_id?',
            name: 'template-popup',
            component: TemplatePopupForm,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 13,
                actions: ['view'],
              },
            },
          },
          {
            path: ':folder_id/notification/:file_id?',
            name: 'template-notification',
            component: TemplateWebForm,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 13,
                actions: ['view'],
              },
            },
          },
          {
            path: ':folder_id/web/:file_id?',
            name: 'template-web',
            component: TemplateWebForm,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 13,
                actions: ['view'],
              },
            },
          },
        ],
      },
      {
        path: 'target-group',
        component: Category,
        meta: {
          middleware: checkPermission,
          permissions: {
            moduleId: 18,
            actions: ['view'],
          },
        },
        children: [
          {
            // folder
            path: '',
            name: 'target-groups-folders',
            component: TargetGroupsFolder,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 18,
                actions: ['view'],
              },
            },
          },
          {
            // files
            path: ':folder_id',
            name: 'target-groups-files',
            component: TargetGroupsFiles,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 18,
                actions: ['view'],
              },
            },
          },
          {
            path: ':folder_id/:action/:id?',
            name: 'target-groups-create',
            component: TargetGroupsForm,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 18,
                actions: ['view', 'create'],
              },
            },
          },
          {
            path: 'explorer',
            name: 'target-groups-explorer',
            component: TargetGroupsForm,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 18,
                actions: ['view', 'create'],
              },
            },
          },
        ],
      },
      {
        path: 'campaigns',
        name: 'campaigns',
        component: Campaigns,
        meta: {
          middleware: checkPermission,
          permissions: {
            moduleId: 19,
            actions: ['view'],
          },
        },
      },
      {
        path: 'campaigns/create',
        name: 'create-campaign',
        component: CreateCampaign,
      },
      {
        path: 'webhooks',
        name: 'webhooks',
        component: Webhooks,
        meta: {
          middleware: checkPermission,
          permissions: {
            moduleId: 14,
            actions: ['view'],
          },
        },
        children: [
          {
            path: 'create',
            name: 'webhook-create',
            component: CreateWebhook,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 14,
                actions: ['view', 'create'],
              },
            },
          },
        ],
      },
      {
        path: 'planner',
        name: 'planner',
        component: Planner,
        meta: {
          middleware: checkPermission,
          permissions: {
            moduleId: 21,
            actions: ['view'],
          },
        },
      },
      {
        path: 'manage-exclusions',
        name: 'manage-exclusions',
        component: ManageExclusions,
      },
    ],
  },

  {
    path: '/user-management',
    component: Category,
    children: [
      {
        path: 'user-group',
        component: Category,
        meta: {
          middleware: checkPermission,
          permissions: {
            moduleId: 7,
            actions: ['view'],
          },
        },
        children: [
          {
            path: '',
            name: 'UserGroup',
            component: UserGroup,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 7,
                actions: ['view'],
              },
            },
          },
          {
            path: 'create',
            name: 'UserGroupCreate',
            component: UserGroupForm,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 7,
                actions: ['view', 'create'],
              },
            },
          },
          {
            path: 'edit/:id',
            name: 'UserGroupEdit',
            component: UserGroupForm,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 7,
                actions: ['view', 'alter'],
              },
            },
          },
        ],
      },
      {
        path: 'user',
        component: Category,
        meta: {
          middleware: checkPermission,
          permissions: {
            moduleId: 8,
            actions: ['view'],
          },
        },
        children: [
          {
            path: '',
            name: 'User',
            component: User,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 8,
                actions: ['view'],
              },
            },
          },
          {
            path: 'create',
            name: 'UserCreate',
            component: UserCreate,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 8,
                actions: ['view', 'create'],
              },
            },
          },
          {
            path: 'edit/:id',
            name: 'UserEdit',
            component: UserEdit,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 8,
                actions: ['view', 'alter'],
              },
            },
          },
        ],
      },
    ],
  },
  {
    path: '/settings',
    component: Category,
    meta: {
      middleware: checkPermission,
      permissions: {
        moduleId: 4,
        actions: ['view'],
      },
    },
    children: [
      {
        path: 'global',
        name: 'GlobalSettings',
        component: GlobalSettings,
        meta: {
          middleware: checkPermission,
          permissions: {
            moduleId: 27,
            actions: ['view'],
          },
        },
      },
      {
        path: 'brand',
        component: Category,
        meta: {
          middleware: checkPermission,
          permissions: {
            moduleId: 15,
            actions: ['view'],
          },
        },
        children: [
          {
            path: 'defaults',
            name: 'BrandDefaults',
            component: BrandDefaults,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 17,
                actions: ['view'],
              },
            },
          },
          {
            path: 'integration-setup',
            name: 'IntegrationSetup',
            component: IntegrationSetup,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 16,
                actions: ['view'],
              },
            },
          },
          {
            path: 'integration-setup/edit/:id',
            name: 'integration-setup-edit',
            component: EditIntegrationSetup,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 16,
                actions: ['view', 'alter'],
              },
            },
          },
          {
            path: 'integration-setup/create',
            name: 'integration-setup-create',
            component: CreateIntegrationSetup,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 16,
                actions: ['view', 'create'],
              },
            },
          },
          {
            path: 'short-links',
            name: 'ShortLinks',
            component: ShortLinks,
            meta: {
              middleware: checkPermission,
              permissions: {
                moduleId: 20,
                actions: ['view'],
              },
            },
          },
        ],
      },
    ],
  },

  {
    path: '/monitoring',
    component: Category,
    children: [
      {
        path: 'user-activity',
        name: 'UserActivity',
        component: UserActivity,
        meta: {
          middleware: checkPermission,
          permissions: {
            moduleId: 9,
            actions: ['view'],
          },
        },
      },
    ],
  },

  {
    path: '/reports',
    component: Category,
    children: [
      {
        path: 'campaign-impression',
        name: 'campaign-impression',
        component: CampaignImpression,
        meta: {
          middleware: checkPermission,
          permissions: {
            moduleId: 24,
            actions: ['view'],
          },
        },
      },
      {
        path: 'customer-360',
        name: 'customer-360',
        component: Customer360,
        meta: {
          middleware: checkPermission,
          permissions: {
            moduleId: 25, // Using campaign module ID for now, adjust as needed
            actions: ['view'],
          },
        },
      },
    ],
  },

  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    children: [],
  },

  {
    meta: {
      // Explicitly don't require auth for the 403 page
      requiresAuth: false,
      // Don't apply any permission middleware
      skipPermissionCheck: true,
    },
    path: '/unauthorized',
    name: 'Unauthorized',
    component: Unauthorized,
  },

  {
    path: '/:pathMatch(.*)*', // Catch-all route for 404
    name: 'NotFound',
    component: NotFound,
  },
];

export default routes;
